import { render, staticRenderFns } from "./Printings.vue?vue&type=template&id=1828df34"
import script from "./Printings.vue?vue&type=script&lang=js"
export * from "./Printings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports